import { ORDERS_DOWNLOADED, ORDERS_FETCHING } from "./../actions";

const initialState = {
	orders: [],
	ordersIsLoading: false
};

export default function order(state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case ORDERS_DOWNLOADED: {
			let orders = Object.values(payload);
			return { ...state, orders: orders };
		}
		case ORDERS_FETCHING: {
			return { ...state, ordersIsLoading: payload };
		}
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/order.js